// extracted by mini-css-extract-plugin
export default {"Reviews":"Review_Reviews__upB6Q"};